import { useQuery } from '@tanstack/react-query'
import { useDB } from './useDB.tsx'
import { DECK_KEYS } from './useDecks.ts'
import { loadUserSettings } from '../lib/auth/local-storage.ts'
import { planReviewNow } from '../lib/fsrs/review-now.ts'
import type { ReviewNowPlan } from '../lib/fsrs/review-now.ts'

/**
 * Under the decks key on purpose: everything that invalidates decks (a
 * finished session, an import, a sync) refreshes the plan too.
 */
export const REVIEW_NOW_KEY = [...DECK_KEYS.all, 'review-now'] as const

/** The "Repasar ahora" plan for Inicio (see lib/fsrs/review-now.ts). */
export function useReviewNowPlan() {
  const { service, isReady } = useDB()
  return useQuery({
    queryKey: REVIEW_NOW_KEY,
    queryFn: (): Promise<ReviewNowPlan> => planReviewNow(service!, loadUserSettings()),
    enabled: isReady && service !== null,
    // Cards become due as time passes, not only when data changes.
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  })
}
